// todo, make generic geo element from this.
import { HtmlComponent } from './../../html-component';
import { Gui } from './../../../gui';
import { MapPopupItem } from './map-popup-item/map-popup-item';
import { EmployeeDataType } from './../../../../data-management/data-sources/sources/employees-data-source';

// import html
import template from './map-popup.hogan.html';

export class MapPopup extends HtmlComponent {
    private currentItems: MapPopupItem[];

    constructor(private gui: Gui) {
        super(template, {});
        this.jqueryElement.hide();
    }

    public showAndPopulate(items: EmployeeDataType[], location: { x: number; y: number }) {
        this.jqueryElement.show();

        if (this.currentItems) {
            this.currentItems.forEach(el => {
                el.jqueryElement.detach();
            });
        }

        this.currentItems = items.map(el => {
            const newEl = new MapPopupItem(this.gui, this, el);
            newEl.addToJqueryTag('.map-popup-container', this);
            return newEl;
        });

        this.jqueryElement.css({
            top: location.y - this.jqueryElement.outerHeight() - 5,
            left: location.x - this.jqueryElement.outerWidth() / 2
        });
    }

    public hide() {
        this.jqueryElement.hide();
    }
}
